module.exports = __webpack_public_path__ + "img/Juniper_Logo.fdd05099.png";